module.exports = __webpack_public_path__ + "assets/img/none.d47371e2.svg";